import { AppState } from "store/rootReducer";
import { createSelector } from "reselect";

const templatesState = (state: AppState) => state.templates.definition;

export const getTemplateDefinitionProcessingState = createSelector(
    templatesState,
    ({ hasError, isProcessing, isSubmitted, validationErrorMessage, isValidationSuccessful }) => ({
        hasError,
        isProcessing,
        isSubmitted,
        isValidationSuccessful,
        validationErrorMessage,
    })
);

// export const getBodyDetails = createSelector(templatesState, ({ templateBody }) => templateBody);

export const getTemplatePreview = createSelector(templatesState, ({ templatePreview }) => templatePreview);

export const getTemplateDefinition = createSelector(templatesState, ({ templateDefinition }) => templateDefinition);
